import { useSuspenseQuery } from "@tanstack/react-query";

import { tableQueryOptions } from "@/web/lib/tanstack";
import { tables } from "@tycho/web-bindings";
import type { CurrentUserRow } from "@tycho/web-bindings/types";

export function useUser(): CurrentUserRow | null {
  const { data } = useSuspenseQuery(tableQueryOptions(tables.currentUser));
  return (data[0] ?? null) as CurrentUserRow | null;
}
